import { configureStore } from '@reduxjs/toolkit';
import CustomizerReducer from './customizer/CustomizerSlice';
import RoleReducer from './Roles/RoleSlice';

export const store = configureStore({
  reducer: {
    customizer: CustomizerReducer,
    role: RoleReducer,
  },
});

export default store;
